import React, { ReactElement } from 'react';
import { trans, gameStartsAt } from '../helpers/helperFunctions';

type WidgetInfoProps = {
  gameStage: string;
  gameDate: string;
};

const WidgetInfo = ({ gameStage, gameDate }: WidgetInfoProps): ReactElement => {
  const stage = gameStage === '' ? 'not-started' : gameStage;
  const displayInfo =
    stage === 'not-started' ? `${trans(stage)} (${gameStartsAt(gameDate)})` : trans(stage);

  return (
    <div className="widget-information">
      <span className="widget-information-text"> {displayInfo}</span>
    </div>
  );
};

export default WidgetInfo;
